import _package from '../../package.json';
import { dynamicEnvironment } from './review-utils';
export const version = _package?.version;
export const environment = {
    production: true,
    hmr: false,
    demographicsUrl: 'https://staging-demographics-api.gapmaps.com/api',
    adminUrl: 'https://staging-admin-api.gapmaps.com',
    authUrl: 'https://staging-auth.gapmaps.com',
    imageBucket: 'gapmaps-staging-images',
    imageBaseUrl: 'https://staging-images.gapmaps.com',
    marketReportsUrl: 'https://marketreports.gapmaps.com',
    metadataUrl: 'https://staging-retailers.gapmaps.com/gapmaps/1.0/meta',
    retailersUrl: 'https://staging-retailers.gapmaps.com/gapmaps/1.0/retailer',
    retailerUrl:'https://staging-retailers.gapmaps.com',
    storageUrl: 'https://staging-storage-api.gapmaps.com',
    areasUrl: 'https://staging-retailers.gapmaps.com/gapmaps/1.0/area',
    webPushBrokerUrl: 'https://staging-broker-api.gapmaps.com',
    scraperUrl:'https://staging-scraper-api.gapmaps.com',
    businessAdminAPIUrl:'https://staging-business-admin-api.gapmaps.com',
    geocoderUrl:'https://geocoder.gapmaps.com/pelias/api',
    GapMaps2APP:"https://staging-live.gapmaps.com",
    locationAPIUrl:'https://staging-location2-api.gapmaps.com/gapmaps',
    googleMapkey:'AIzaSyAO-bPZp2XWXvWorv_J45bNDf-Z-1DUYn0',
    layersUrl:"https://staging-layers-api.gapmaps.com",
    analyticsApiUrl:'https://staging-analytics-api.gapmaps.com',
    dbUrl:'https://staging-data.gapmaps.com',
    poiAPIUrl:'https://staging-poi-api.gapmaps.com',
    mapbox: {
        token: "pk.eyJ1IjoiZ2FwbWFwcyIsImEiOiJjamZrZmszM3gwNHBoMndxZmNuYWgxMHVtIn0.n_HlXw7ugA4Y4qScnslikQ"
    },
    version,
    logRocket:'q2rgxh/gm-admin-staging',
    keycloak: {
        url: 'https://staging-auth1.gapmaps.com',
        adminUrl: 'https://staging-auth1-admin.gapmaps.com',
        realm: 'gapmaps',
        clientId: 'gapmaps2-app',
    },
    ...dynamicEnvironment()
};
